// extracted by mini-css-extract-plugin
export var cell = "deployment-options-module--cell--7a57c";
export var contentGroup = "deployment-options-module--contentGroup--a81da";
export var desktopTable = "deployment-options-module--desktopTable--cb91c";
export var flex = "deployment-options-module--flex--e9b65";
export var headerCell = "deployment-options-module--headerCell--1cf7c";
export var headerImage = "deployment-options-module--headerImage--313a1";
export var headerRow = "deployment-options-module--headerRow--4c0ba";
export var headerText = "deployment-options-module--headerText--cbec1";
export var mobileCell = "deployment-options-module--mobileCell--6ed50";
export var mobileRow = "deployment-options-module--mobileRow--a662c";
export var mobileTable = "deployment-options-module--mobileTable--4a121";
export var mobileTableContent = "deployment-options-module--mobileTableContent--c19a7";
export var mobileTableHeader = "deployment-options-module--mobileTableHeader--c5aa2";
export var root = "deployment-options-module--root--e77f1";
export var row = "deployment-options-module--row--fa89f";